module.exports = __webpack_public_path__ + "img/good5.cb497bc7.jpg";